import { useRef, useCallback } from "react";

export function useScrollMemory() {
  const ref = useRef(null);
  const savedPos = useRef(0);

  const save = useCallback(() => {
    if (ref.current) savedPos.current = ref.current.scrollTop;
  }, []);

  const restore = useCallback(() => {
    if (ref.current) {
      requestAnimationFrame(() => {
        if (ref.current) ref.current.scrollTop = savedPos.current;
      });
    }
  }, []);

  return { ref, save, restore };
}
